function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 2.5C6.084 2.5 2.5 6.084 2.5 10.5C2.5 14.916 6.084 18.5 10.5 18.5C14.916 18.5 18.5 14.916 18.5 10.5C18.5 6.084 14.916 2.5 10.5 2.5",
  stroke: "black",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.6284 5C11.3456 5 11.9557 5.15278 12.4587 5.45833C12.9725 5.75335 13.3578 6.14847 13.6147 6.64368C13.8716 7.13889 14 7.66571 14 8.22414C14 8.82471 13.8662 9.31992 13.5986 9.70977C13.331 10.0891 12.9564 10.4842 12.4748 10.8951C12.143 11.1901 11.8968 11.4377 11.7362 11.6379C11.5864 11.8381 11.5115 12.0594 11.5115 12.3017V13.0761H9.90596V12.0647C9.90596 11.7064 10.013 11.3851 10.2271 11.1006C10.4411 10.8056 10.7569 10.4631 11.1743 10.0733C11.5917 9.67289 11.9021 9.33573 12.1055 9.06178C12.3089 8.78784 12.4106 8.47701 12.4106 8.12931C12.4106 7.6341 12.2286 7.22318 11.8647 6.89655C11.5008 6.56992 11.0512 6.40661 10.5161 6.40661C9.92737 6.40661 9.45642 6.56992 9.10321 6.89655C8.7607 7.22318 8.58945 7.6499 8.58945 8.17672L7 8.16092C7 7.65517 7.13914 7.15996 7.41743 6.67529C7.69572 6.19061 8.10245 5.79023 8.63761 5.47414C9.17278 5.15805 9.80428 5 10.5321 5H10.6284ZM10.75 16C11.3023 16 11.75 15.5523 11.75 15C11.75 14.4477 11.3023 14 10.75 14C10.1977 14 9.75 14.4477 9.75 15C9.75 15.5523 10.1977 16 10.75 16Z",
  fill: "black"
});

function SvgIconQuery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuery);
export default __webpack_public_path__ + "static/media/icon-query.e0ccd607.svg";
export { ForwardRef as ReactComponent };